<div class="modal-header headerRow" id="modal-header">
  <h3  *ngIf="!message.boldTitle" class="modal-title h3" id="modal-title">{{ message.title }}</h3>
  <h3  *ngIf="message.boldTitle" class="modal-title h3" id="modal-title"><b>{{ message.title }}</b></h3>
  <button type="button" class="close" (click)="close()" id="close-button" *ngIf="message.showCloseButtonX">&times;</button>
</div>
<div class="modal-body textRow" id="modal-body">
  <span [innerHTML]="message.text" id="message-text"></span>
</div>
<div class="modal-footer footerRow" id="modal-footer">
  <button type="button" class="btn btn-standard" (click)="close()" id="close-button-with-text" *ngIf="message.showCloseButton"><i class="fa fa-times"></i> {{ message.closeButtonText }}</button>
  <button type="button" class="btn btn-standard" (click)="confirm()" id="confirm-button"><i class="fa fa-check"></i> {{ message.okButtonText }}</button>
</div>
